import React from 'react'

import { Link } from 'gatsby'
import {
  Layout,
  Intro,
  Showcase,
  SectionTitle,
  Header,
} from '../../../../components'

import './style.scss'
import data from './data.json'

export default () => {
  function toggleEnabled() {
    document
      .querySelector('.c-radio__container--input')
      .removeAttribute('disabled')
  }
  function toggleDisabled() {
    document.querySelector('.c-radio__container--input').value = ''
    document
      .querySelector('.c-radio__container--input')
      .setAttribute('disabled', '')
  }
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      />
      <Layout
        complete={true}
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      >
        <Intro>
          <p>
            Radios are a type of form input that allows the user to select a
            single option from a given list. To allow the user to select
            multiple options, use the{' '}
            <Link
              to={'/' + data.site + '/components/checkbox/design/'}
              className="link"
            >
              checkbox
            </Link>{' '}
            component.
          </p>
        </Intro>
        <SectionTitle>Variants</SectionTitle>
        {/* <Showcase
          site={data.site}
          title="Radio Buttons"
          text={
            <p>
              The radio button component includes a text label for each option
              and a transparent container outlined in gray that holds the full
              list of selectable options. In addition to the default state,
              every option has a hover state, a focus state, and a checked
              state. The error state takes the form of an{' '}
              <Link
                to={'/' + data.site + '/components/inline-error/design/'}
                className="link"
              >
                input error
              </Link>{' '}
              component.
            </p>
          }
        >
          <div class="c-radio-group">
            <div class="c-radio__container--none">
              <input type="radio" name="option" id="option1" />
              <label htmlFor="option1">Option 1</label>
            </div>
            <div class="c-radio__container--none">
              <input type="radio" name="option" id="option2" />
              <label htmlFor="option2">Option 2</label>
            </div>
            <div class="c-radio__container--none">
              <input type="radio" name="option" id="option3" />
              <label htmlFor="option3">Option 3</label>
            </div>
          </div>
        </Showcase> */}
        <Showcase
          site={data.site}
          title="Default Radio Button"
          text={
            <p>
              The radio button component includes a text label for each option
              and a transparent container outlined in gray that holds the full
              list of selectable options.
            </p>
          }
        >
          <div class="c-radio-group">
            <div class="c-radio__container">
              <input type="radio" name="default" id="option1" />
              <label htmlFor="option1">Option 1</label>
            </div>
            <div class="c-radio__container">
              <input type="radio" name="default" id="option2" />
              <label htmlFor="option2">Option 2</label>
            </div>
            <div class="c-radio__container">
              <input type="radio" name="default" id="option3" />
              <label htmlFor="option3">Option 3</label>
            </div>
          </div>
        </Showcase>
        <Showcase
          site={data.site}
          title="Radio with Subtitle"
          text={
            <p>
              Use this variant when you need to include secondary or
              supplementary information to give a user further context in order
              to make a choice.
            </p>
          }
        >
          <div class="c-radio-group">
            <div class="c-radio__container">
              <input type="radio" name="subtitle" id="option1-subtitle" />
              <label htmlFor="option1-subtitle">
                Option 1
                <span class="c-radio__container--text">
                  Content goes here...more content
                </span>
              </label>
            </div>
            <div class="c-radio__container">
              <input type="radio" name="subtitle" id="option2-subtitle" />
              <label htmlFor="option2-subtitle">
                Option 2
                <span class="c-radio__container--text">
                  Content goes here...more content
                </span>
              </label>
            </div>
            <div class="c-radio__container">
              <input type="radio" name="subtitle" id="option3-subtitle" />
              <label htmlFor="option3-subtitle">
                Option 3
                <span class="c-radio__container--text">
                  Content goes here...more content
                </span>
              </label>
            </div>
          </div>
        </Showcase>
        <Showcase
          site={data.site}
          title="Radio with Nested Input"
          text={
            <span>
              <p>
                Optionally, the last button in a radio list may contain a text
                input. There may only be one radio of this type in a list and it
                must appear after all other options to be accessible. The text
                input remains disabled unless the corresponding radio option is
                selected.
              </p>
            </span>
          }
        >
          <div class="c-radio-group">
            <div class="c-radio__container">
              <input
                onKeyUp={event => toggleDisabled()}
                type="radio"
                name="nested"
                id="option1-nested"
              />
              <label
                onKeyDown={event => toggleDisabled()}
                onClick={event => toggleDisabled()}
                htmlFor="option1-nested"
              >
                Option 1
                <span class="c-radio__container--text">
                  Content goes here...more content
                </span>
              </label>
            </div>
            <div class="c-radio__container">
              <input
                onKeyUp={event => toggleDisabled()}
                type="radio"
                name="nested"
                id="option2-nested"
              />
              <label
                onKeyDown={event => toggleDisabled()}
                onClick={event => toggleDisabled()}
                htmlFor="option2-nested"
              >
                Option 2
                <span class="c-radio__container--text">
                  Content goes here...more content
                </span>
              </label>
            </div>
            <div class="c-radio__container">
              <input
                onKeyUp={event => toggleEnabled()}
                onClick={event => toggleEnabled()}
                type="radio"
                name="nested"
                id="option3-nested"
              />
              <label htmlFor="option3-nested">
                Other:
                <input
                  type="text"
                  name="nested"
                  class="c-radio__container--input"
                  disabled
                />
              </label>
            </div>
          </div>
        </Showcase>
        <hr />
        <SectionTitle>States</SectionTitle>
        <p>
          In addition to the default state, every radio button option has a
          hover state, a focus state, and a selected state. The error state,
          however, affects the entire list container.
        </p>

        <hr />
        <SectionTitle>Design Environment</SectionTitle>
        <Showcase
          site={data.site}
          title="Radio Button Error"
          text={
            <p>
              A radio group in the error state must be used with an{' '}
              <Link
                to={'/' + data.site + '/components/inline-error/design/'}
                className="link"
              >
                input error
              </Link>{' '}
              component to guide the user in correcting the error.
            </p>
          }
        >
          <div class="c-radio-group c-radio-group--error">
            <div class="c-radio__container">
              <input type="radio" name="default" id="option1" />
              <label htmlFor="option1">Option 1</label>
            </div>
            <div class="c-radio__container">
              <input type="radio" name="default" id="option2" />
              <label htmlFor="option2">Option 2</label>
            </div>
            <div class="c-radio__container">
              <input type="radio" name="default" id="option3" />
              <label htmlFor="option3">Option 3</label>
            </div>
          </div>
          <span class="c-inline-error">
            <i class="icon icon--error c-inline-error__icon"></i>
            <span class="c-inline-error__content">You must decide.</span>
          </span>
        </Showcase>
        <hr />

        <SectionTitle>Microcopy</SectionTitle>
        <p>
          Text labels can be full sentences or fragments, but stay consistent
          within the same list. If fragments, all options should use the same
          part of speech (e.g. all nouns or all verbs) rather than mixing. Use
          sentence case with no end punctuation, unless the text is a question.
        </p>
        <p>
          The label radios with nested inputs should be 'Other - Please
          specify'. This will give users who rely on a screenreader an audible
          cue that there is an input associated with the radio that must be
          filled out.
        </p>
      </Layout>
    </>
  )
}
